import initialState from './initialState';
import CRUD_ACTION_TYPES, { getNamedAction } from 'actions/CRUD_ACTION_TYPES';
import ACTION_NAMES from 'actions/ACTION_NAMES';
import { FALLBACK_SEATS, toPlanAccess } from 'actions/onboarding/planAccess';

function onboardingReducer(state = initialState, action) {
    switch (action.type) {
        case getNamedAction(ACTION_NAMES.ONBOARDING_WEBSITE_DISCOVERY, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isDiscoveringWebsite: true };
        case getNamedAction(ACTION_NAMES.ONBOARDING_WEBSITE_DISCOVERY, CRUD_ACTION_TYPES.CREATE_SUCCESS):
        case getNamedAction(ACTION_NAMES.ONBOARDING_WEBSITE_DISCOVERY, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isDiscoveringWebsite: false };

        case getNamedAction(ACTION_NAMES.ONBOARDING_RECOMMENDATIONS, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isGeneratingRecommendations: true };
        case getNamedAction(ACTION_NAMES.ONBOARDING_RECOMMENDATIONS, CRUD_ACTION_TYPES.CREATE_SUCCESS):
        case getNamedAction(ACTION_NAMES.ONBOARDING_RECOMMENDATIONS, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isGeneratingRecommendations: false };

        case getNamedAction(ACTION_NAMES.ONBOARDING_TEAM_STRUCTURE, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isGeneratingTeamStructure: true };
        case getNamedAction(ACTION_NAMES.ONBOARDING_TEAM_STRUCTURE, CRUD_ACTION_TYPES.CREATE_SUCCESS):
        case getNamedAction(ACTION_NAMES.ONBOARDING_TEAM_STRUCTURE, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isGeneratingTeamStructure: false };

        case getNamedAction(ACTION_NAMES.ONBOARDING_EXTRACT_INVITES, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isExtractingInvites: true };
        case getNamedAction(ACTION_NAMES.ONBOARDING_EXTRACT_INVITES, CRUD_ACTION_TYPES.CREATE_SUCCESS):
        case getNamedAction(ACTION_NAMES.ONBOARDING_EXTRACT_INVITES, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isExtractingInvites: false };

        case getNamedAction(ACTION_NAMES.ONBOARDING_PHONE_SETUP, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isGeneratingPhoneSetup: true };
        case getNamedAction(ACTION_NAMES.ONBOARDING_PHONE_SETUP, CRUD_ACTION_TYPES.CREATE_SUCCESS):
        case getNamedAction(ACTION_NAMES.ONBOARDING_PHONE_SETUP, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isGeneratingPhoneSetup: false };

        case getNamedAction(ACTION_NAMES.ONBOARDING_DRAFT_GREETINGS, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isDraftingGreetings: true };
        case getNamedAction(ACTION_NAMES.ONBOARDING_DRAFT_GREETINGS, CRUD_ACTION_TYPES.CREATE_SUCCESS):
        case getNamedAction(ACTION_NAMES.ONBOARDING_DRAFT_GREETINGS, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isDraftingGreetings: false };

        case getNamedAction(ACTION_NAMES.ONBOARDING_CRM_SETUP, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isGeneratingCrmSetup: true };
        case getNamedAction(ACTION_NAMES.ONBOARDING_CRM_SETUP, CRUD_ACTION_TYPES.CREATE_SUCCESS):
        case getNamedAction(ACTION_NAMES.ONBOARDING_CRM_SETUP, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isGeneratingCrmSetup: false };

        case getNamedAction(ACTION_NAMES.ONBOARDING_MESSAGING_SETUP, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isGeneratingMessagingSetup: true };
        case getNamedAction(ACTION_NAMES.ONBOARDING_MESSAGING_SETUP, CRUD_ACTION_TYPES.CREATE_SUCCESS):
        case getNamedAction(ACTION_NAMES.ONBOARDING_MESSAGING_SETUP, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isGeneratingMessagingSetup: false };

        case getNamedAction(ACTION_NAMES.ONBOARDING_COLUMN_MAPPING, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isMappingColumns: true };
        case getNamedAction(ACTION_NAMES.ONBOARDING_COLUMN_MAPPING, CRUD_ACTION_TYPES.CREATE_SUCCESS):
        case getNamedAction(ACTION_NAMES.ONBOARDING_COLUMN_MAPPING, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isMappingColumns: false };

        case getNamedAction(ACTION_NAMES.ONBOARDING_ANALYZE_IMPORT, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isAnalyzingImport: true };
        case getNamedAction(ACTION_NAMES.ONBOARDING_ANALYZE_IMPORT, CRUD_ACTION_TYPES.CREATE_SUCCESS):
        case getNamedAction(ACTION_NAMES.ONBOARDING_ANALYZE_IMPORT, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isAnalyzingImport: false };

        case getNamedAction(ACTION_NAMES.ONBOARDING_SAMPLE_IMPORT, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isLoadingSampleImport: true };
        case getNamedAction(ACTION_NAMES.ONBOARDING_SAMPLE_IMPORT, CRUD_ACTION_TYPES.CREATE_SUCCESS):
        case getNamedAction(ACTION_NAMES.ONBOARDING_SAMPLE_IMPORT, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isLoadingSampleImport: false };

        case getNamedAction(ACTION_NAMES.ONBOARDING_INTEGRATIONS, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isGeneratingIntegrations: true };
        case getNamedAction(ACTION_NAMES.ONBOARDING_INTEGRATIONS, CRUD_ACTION_TYPES.CREATE_SUCCESS):
        case getNamedAction(ACTION_NAMES.ONBOARDING_INTEGRATIONS, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isGeneratingIntegrations: false };

        case getNamedAction(ACTION_NAMES.ONBOARDING_PLAN_ACCESS, CRUD_ACTION_TYPES.READ_ONE_REQUEST):
            return { ...state, isReadingPlan: true };
        case getNamedAction(ACTION_NAMES.ONBOARDING_PLAN_ACCESS, CRUD_ACTION_TYPES.READ_ONE_SUCCESS):
            return { ...state, isReadingPlan: false, plan: toPlanAccess(action.data) };
        case getNamedAction(ACTION_NAMES.ONBOARDING_PLAN_ACCESS, CRUD_ACTION_TYPES.READ_ONE_FAILURE):
            return { ...state, isReadingPlan: false };

        case getNamedAction(ACTION_NAMES.ONBOARDING_PLAN_SEATS, CRUD_ACTION_TYPES.READ_ONE_SUCCESS):
            return { ...state, seats: action.data };
        case getNamedAction(ACTION_NAMES.ONBOARDING_PLAN_SEATS, CRUD_ACTION_TYPES.READ_ONE_FAILURE):
            return { ...state, seats: FALLBACK_SEATS };

        case 'RESET_ONBOARDING':
            return initialState;

        default:
            return state;
    }
}

export default onboardingReducer;
